<template>
  <v-app ligth>
    <v-navigation-drawer
      id="navigation-1"
      fixed
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      app      
      dark            
      v-if="showMenu"
    >
      <v-list dense>
          <v-list-tile>
            <v-list-tile-action>
              <v-btn
                icon
                @click.native.stop="miniVariant = !miniVariant">
                <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
            </v-list-tile-content>
          </v-list-tile>

        <!-- v-subheader >Administação</v-subheader -->
        <v-list-tile          
          active-class="itemmenu--text"
          v-for="(item, i) in menuApp"
          :key="i"
          :to="item.to"
          :value="item.active" 
          exact
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title> {{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile          
          active-class="itemmenu--text"          
          v-if="logado==null"
          to="/"
          exact>
          <v-list-tile-action>
            <v-icon>account_circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Entrar</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      
        <v-list-tile          
          active-class="itemmenu--text"          
          v-if="logado!=null"
          to="/redefinir-senha"
          exact>
          <v-list-tile-action>
            <v-icon>password</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Alterar Senha</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile          
          active-class="itemmenu--text"          
          v-if="logado!=null"
          @click="logout()"
          exact>
          <v-list-tile-action>
            <v-icon>account_circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>


      </v-list>

    </v-navigation-drawer>

    <v-toolbar dense dark fixed app :clipped-left="clipped" color="primary" v-if="showMenu">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" ></v-toolbar-side-icon>
      <v-toolbar-title dark  >
        <a target="_empresaOut" class="linkTitulo" :href="linkEmpresa">{{tituloApp}}</a>        
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items  class="hidden-sm-and-down"
                :key="i"
          v-for="(item, i) in menuApp"
      >
        <v-btn flat
        router
        v-if="item.to && !item.menuPai"
        :to="item.to">{{item.title}}</v-btn>
      
        <v-menu 
          attach
          bottom
          left
          offset-y
          max-height="500"
          v-if="!item.to"
          >

          <v-btn flat slot="activator">
            {{item.title}}
          </v-btn>


          <v-list>
            
            <v-list-tile flat v-for="(filho, f) in item.filhos"
            :key="f"
            router
            :to="filho.to">
              <v-list-tile-title>{{filho.title}}</v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>
      </v-toolbar-items>


      <v-menu left bottom origin="top right" transition="v-scale-transition">
        <v-btn dark icon slot="activator">
          <v-icon>account_circle</v-icon>
        </v-btn>
        <v-list>
          
          <v-list-tile v-if="logado!=null" to="/redefinir-senha">
            <v-list-tile-title>Alterar Senha</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="logado==null" to="/">
            <v-list-tile-title>Entrar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="logado!=null" @click="logout()">
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>    
  </v-app>
</template>

<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        clipped: true,
        drawer: false,
        miniVariant: true,
        title: 'Mezzow QR'
      }
    },
    watch: {
      search () {
        // this.$store.commit('changeCabecalho', {query: this.search})
      }
    },
    methods: {
      logout () {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('user')
        axios.defaults.headers.common['Authorization'] = null
        this.$store.commit('changeMenu', {menu: []})
        this.$store.commit('changeUser', {user: null})
        this.$router.push({path: '/login'})
      },
      buscaMenu () {
        this.$store.commit('changeMenu', this.$route.params)
      }
    },
    computed: {
      menuApp () {
        return this.$store.state.menu ? this.$store.state.menu : []
      },
      tituloApp () {
        return this.$store.state.cabecalho.nomeEmpresa ? this.$store.state.cabecalho.nomeEmpresa : this.title
      },
      linkEmpresa () {
        return this.$store.state.cabecalho.site
      },
      showMenu () {
        console.log('rota ', this.$route.name)
        return (this.$route.name !== 'Login' &&
          this.$route.name !== 'LoginEmpresa' &&
          this.$route.name !== 'RedefinirSenha' &&
          this.$route.name !== 'CartaoAcesso')
      },
      logado () {
        console.log('this.$store.state.userLogin ' + this.$store.state.userLogin)
        return this.$store.state.userLogin
      }
    },
    created () {
      this.buscaMenu()
    }
  }
</script>

<style>
.application a.linkTitulo{
  color: #ffffff;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?fb2e57a0